/**
 * Name: Navigation
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Navigation extends Collapsible {
  static settings = {
    control: '.js-navigation-control',
    target: '.js-navigation-megamenu',
    close: '.js-navigation-close',
  };

  #control;
  #closeButtons;


  constructor (element, options = {}) {
    super(element, {
      ...Navigation.settings,
      ...options,
    });

    this.#control = this.element.querySelector('.js-navigation-control');
    this.#closeButtons = this.element.querySelectorAll('.js-navigation-close');
  }

  checkMegamenuOverflow () {
    if (!this.target || !this.#control) return;

    const menuRect = this.target.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const overflowLeft = menuRect.left < 0;
    const overflowRight = menuRect.right > viewportWidth;

    if (overflowLeft) {
      this.target.classList.add('is-overflow-left');
    } else {
      this.target.classList.remove('is-overflow-left');
    }

    if (overflowRight) {
      this.target.classList.add('is-overflow-right');
    } else {
      this.target.classList.remove('is-overflow-right');
    }
  }

  open () {
    super.open();
    document.querySelector('header').classList.add('megamenu-is-open');
    this.#control.classList.add('active');

    this.target.classList.add('open');

    this.target.classList.remove('is-overflow-left', 'is-overflow-right');

    requestAnimationFrame(() => {
      this.checkMegamenuOverflow();
    });

    this.target.focus();
  }

  close () {
    super.close();
    document.querySelector('header').classList.remove('megamenu-is-open');
    this.#control.classList.remove('active');
  }

  mount () {
    super.mount();
    this.#closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.close()
        setTimeout(() => {
          this.target.classList.remove('open');
        }, 2);
      });
    });
  }

  unmount () {
    super.unmount();
    this.target.classList.remove('megamenu-is-open');
    this.#closeButtons.forEach(button => {
      button.removeEventListener('click', () => {
        this.close()
        setTimeout(() => {
          this.target.classList.remove('open');
        }, 2);
      });
    });
  }
}
